import { axiosV2 } from "config/@axios";

export const FETCH_FAILED_SESSIONS = "failedSessions::failedSessions";
export const FETCH_FAILED_SESSIONS_SUCCESS =
  "failedSessions::failedSessionsSuccess";
export const FETCH_FAILED_SESSIONS_FAILED =
  "failedSessions::failedSessionsFailed";

export const fetchFailedSessions = () => dispatch => {
  dispatch({
    type: FETCH_FAILED_SESSIONS
  });

  const now = new Date();
  const endtime = parseInt(now.getTime() / 1000);
  const starttime = endtime - 86400 * 15;

  return axiosV2
    .get(`logs/authentication`, {
      params: {
        starttime,
        endtime,
        count: 5,
        start: 0,
        status: "ERROR"
      }
    })
    .then(response => {
      dispatch({
        type: FETCH_FAILED_SESSIONS_SUCCESS,
        payload: {
          failedSessions: response.data
        }
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_FAILED_SESSIONS_FAILED,
        payload: {
          errorText: err.errorMessage
        }
      });
    });
};
